module.exports = __webpack_public_path__ + "static/media/kfc-24-1.7ff3e239.jpg";